import type { LinkAudit } from "./types";

export const sampleAudit: LinkAudit = {
  requestedUrl: "https://example.com/launch-page",
  finalUrl: "https://example.com/launch-page",
  hostname: "example.com",
  checkedAt: "2026-06-14T00:00:00.000Z",
  score: 83,
  scoreLabel: "Publish-ready with fixes",
  fetch: {
    status: 200,
    ok: true,
    elapsedMs: 420,
    contentType: "text/html; charset=utf-8",
    error: ""
  },
  summary: {
    total: 12,
    checked: 9,
    passed: 6,
    warnings: 2,
    failures: 1,
    internal: 5,
    external: 4,
    skipped: 3
  },
  links: [
    {
      id: 1,
      href: "/pricing",
      normalizedUrl: "https://example.com/pricing",
      anchor: "Pricing",
      kind: "internal",
      status: 200,
      level: "pass",
      statusText: "200 OK",
      redirected: false,
      redirectChain: [],
      issue: "",
      sourceIndex: 1
    },
    {
      id: 2,
      href: "/old-guide",
      normalizedUrl: "https://example.com/new-guide",
      anchor: "Read the launch guide",
      kind: "internal",
      status: 301,
      level: "warn",
      statusText: "301 Redirect",
      redirected: true,
      redirectChain: ["https://example.com/old-guide", "https://example.com/new-guide"],
      issue: "Update this link to the final destination.",
      sourceIndex: 2
    },
    {
      id: 3,
      href: "https://partner.example/report",
      normalizedUrl: "https://partner.example/report",
      anchor: "2023 partner report",
      kind: "external",
      status: 404,
      level: "fail",
      statusText: "404 Not Found",
      redirected: false,
      redirectChain: [],
      issue: "Replace or remove this dead URL.",
      sourceIndex: 3
    },
    {
      id: 4,
      href: "#features",
      normalizedUrl: "#features",
      anchor: "Features",
      kind: "fragment",
      status: null,
      level: "info",
      statusText: "Fragment",
      redirected: false,
      redirectChain: [],
      issue: "",
      sourceIndex: 4
    }
  ],
  issues: [
    "1 failed link should be fixed before publishing.",
    "2 redirected links can be updated to their final destinations.",
    "3 links were skipped because they are mail, phone, script, or fragment links."
  ],
  report:
    "# LinkPulse report for example.com\n\n- Score: 83/100\n- Checked links: 9\n- Failed links: 1\n- Redirects: 2\n\n## Priority fixes\n\n1. https://partner.example/report returned 404 Not Found. Replace or remove it.\n2. https://example.com/old-guide redirects to https://example.com/new-guide. Update the href."
};
